import React, { useEffect, useState } from 'react'
import Modal from '../../../core/components/UI/Modal'
import useOpportunitiesActions from '../../hooks/useOpportunitiesActions'
import { Link } from 'react-router-dom'
import { MdArrowLeft, MdClose, MdEdit } from 'react-icons/md'
import { datetimeFormat } from '../../../helper'
import ButtonDeleteOpportunity from './ButtonDeleteOpportunity'

export default function ModelOpportunities({ isOpen, onClose, country }) {
  const { getOpportunities } = useOpportunitiesActions()
  const [opportunities, setOpportunities] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  async function fetchOpportunities(countryId) {
    try {
      setIsLoading(true)
      const opportunities = await getOpportunities(countryId)
      setOpportunities(opportunities)
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (isOpen) {
      fetchOpportunities(country.id)
    }
  }, [country.id, isOpen])

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={`h-full w-full border-2 border-muted-500 bg-white xl:w-4/5`}
    >
      <div className="grid max-h-full grid-cols-12 gap-2 overflow-y-auto p-2">
        {opportunities?.map((opportunity) => (
          <div className="col-span-12 flex flex-col lg:col-span-6">
            <div className="flex items-center justify-between border-2 border-muted-500 p-2">
              <div className="line-clamp-1 font-bold">
                {opportunity.title_ar}
              </div>
              <div className="flex items-center gap-2">
                {opportunity.attachment_link && (
                  <Link
                    target={opportunity.title_ar}
                    to={opportunity.attachment_link}
                    className="!line-clamp-1 flex border-2 border-muted-600 bg-muted-100 p-1 px-2 text-xs hover:bg-muted-500"
                  >
                    معلومات إضافية
                  </Link>
                )}
                <Link
                  to={`/countries/${opportunity.country_id}/opportunities/${opportunity.id}/edit`}
                  className="flex border-2 border-primary-500 bg-primary-300 p-1 text-white hover:bg-primary-500"
                >
                  <MdEdit size={16} />
                </Link>
                <ButtonDeleteOpportunity
                  countryId={opportunity.country_id}
                  opportunityId={opportunity.id}
                />
              </div>
            </div>
            <div className="border-2 border-t-0 border-muted-500 p-2 text-[14px]">
              <div className="flex gap-1">
                <label className="font-bold">نوع : </label>
                <div> {opportunity.type_ar} </div>
              </div>
              <div className="flex gap-1">
                <label className="font-bold">الخام : </label>
                <div>{opportunity.raw_materials_ar}</div>
              </div>
              <div className="flex gap-1">
                <label className="font-bold">المساحة (كم2 ) : </label>
                <div>{opportunity.area ?? 'غير محددة'}</div>
              </div>
              <div className="flex gap-1">
                <label className="font-bold">تاريخ : </label>
                <div>
                  {opportunity.started_at
                    ? datetimeFormat(opportunity.started_at, 'Y')
                    : 'غير محدد'}
                </div>
              </div>
              <div className="flex gap-1">
                <label className="font-bold">حالة : </label>
                <div>{opportunity.is_expired ? 'غير نشيطة' : 'نشيطة'}</div>
              </div>

              <div>{opportunity.is_expired}</div>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  )
}
